// // // //
// Client-safe constants for the MCP setup wizard.

/** Default redirect URIs used when creating an OAuth client from the MCP wizard. */
// TODO - update this to include additional callback URLs for other MCP connectors
export const MCP_WIZARD_DEFAULT_REDIRECT_URIS = [
    "https://claude.ai/api/mcp/auth_callback",
] as const;

/** Default scopes used when creating an OAuth client from the MCP wizard. */
export const MCP_WIZARD_DEFAULT_SCOPES = [
    "mcp:query",
    "offline_access",
] as const;
